import React, { useRef, useEffect, useState } from "react";
import Chart from "chart.js/auto";
import styled from "styled-components";
import { EpochToMonthDayString } from "../../../utils";
import BlueBG from "../../../assets/img/blue-background.png";

interface ICustomChartProps {
  plotData?: any;
  title?: any;
  plotDataSidebar?: any;
  sidebar?: boolean;
}

const EngagementChart: React.FC<ICustomChartProps> = (props: ICustomChartProps) => {
  const canvasRef: any = useRef("");
  const canvasRefSidebar: any = useRef("chart");
  const [chartInstance, setChartInstance]: [any, any] = useState(null);

  const ToMonthDayLables = (labels: Array<number>) => {
    return labels?.map((epoch: any) => {
      return EpochToMonthDayString(epoch);
    });
  };

  useEffect(() => {
    if (props.plotDataSidebar) {
      let pDatasets: any = [
        [40, 30],
        [40, 30],
      ];
      let xAxesDateLabels: any = [1, 2];

      if (canvasRefSidebar && canvasRefSidebar.current && xAxesDateLabels) {
        const ChartSidebar = new Chart(canvasRefSidebar.current, {
          type: "line",
          data: {
            labels: xAxesDateLabels,
            datasets: pDatasets,
          },
          options: {
            elements: {
              line: {
                tension: 0.5,
              },
            },
            plugins: {
              tooltip: {
                enabled: false,
                position: "nearest",
              },
              legend: {
                display: true,
                title: {
                  display: true,
                  text: `${props.title}`,
                  position: "center",
                  font: {
                    size: 18,
                  },
                  color: `${props.sidebar ? "#001823" : "white"}`,
                  padding: {
                    top: 10,
                    left: 2,
                  },
                },
                labels: {
                  generateLabels: function (chart) {
                    return [];
                  },
                },
              },
            },
            scales: {
              xAxes: {
                grid: {
                  display: false,
                  borderWidth: 0,
                },
              },
              yAxes: {
                display: false,
              },
            },
          },
        });
        setChartInstance(ChartSidebar);
        return () => {
          ChartSidebar.destroy();
        };
      }
    }
  }, [props?.plotDataSidebar]);

  useEffect(() => {
    if (props.plotData) {
      let pDatasets = [];
      let xAxesDateLabels = [
        "12/01",
        "12/15",
        "01/01",
        "01/15",
        "02/01",
        "02/15",
        "03/01",
        "03/15",
        "04/01",
        "04/15",
        "Today",
      ];
      if (props?.plotData && Object.keys(props?.plotData).length !== 0) {
        let utcEpochs: any = new Set();
        utcEpochs = props?.plotData?.accumulated_campaigns_clicks?.reduce((epochs: Set<number>, dataset: any) => {
          epochs.add(dataset[0]);
          return epochs;
        }, utcEpochs);
        utcEpochs = props?.plotData?.accumulated_campaigns_opens?.reduce((epochs: Set<number>, dataset: any) => {
          epochs.add(dataset[0]);
          return epochs;
        }, utcEpochs);
        const xAxesLabels: Array<any> = utcEpochs && Array.from(utcEpochs)?.sort((a: any, b: any) => a - b);

        const epochsMap = new Map();
        xAxesLabels?.forEach((epoch, index) => {
          epochsMap.set(epoch, index);
        });
        const clicks: Array<any> = new Array(xAxesLabels?.length).fill(null, 0, xAxesLabels?.length);
        const opens: Array<any> = new Array(xAxesLabels?.length).fill(null, 0, xAxesLabels?.length);
        props?.plotData?.accumulated_campaigns_clicks?.forEach((dataset: any) => {
          const epoch: number = dataset[0];
          const ind: number = epochsMap.get(epoch);
          clicks[ind] = dataset[1];
        });
        props?.plotData?.accumulated_campaigns_opens?.forEach((dataset: any) => {
          const epoch: number = dataset[0];
          const ind: number = epochsMap.get(epoch);
          opens[ind] = dataset[1];
        });

        pDatasets.push({
          label: "",
          borderColor: "white",
          pointBorderColor: "white",
          pointBackgroundColor: "white",
          pointBorderWidth: 1,
          pointHoverRadius: 3,
          pointHitRadius: 3,
          data: clicks,
          pointStyle: "rectRot",
          spanGaps: true,
        });
        pDatasets.push({
          label: "",
          borderColor: "white",
          pointBorderColor: "white",
          pointBackgroundColor: "white",
          pointBorderWidth: 1,
          pointHoverRadius: 2,
          pointHitRadius: 3,
          data: opens,
          pointStyle: "triangle",
          spanGaps: true,
        });

        xAxesDateLabels = ToMonthDayLables(xAxesLabels);
      }
      if (canvasRef && canvasRef.current && xAxesDateLabels) {
        const someChart = new Chart(canvasRef.current, {
          type: "line",
          data: {
            labels: xAxesDateLabels,
            datasets: pDatasets,
          },
          options: {
            elements: {
              line: {
                tension: 0.5,
              },
            },
            plugins: {
              tooltip: {
                enabled: false,
                position: "nearest",
              },
              legend: {
                display: true,
                title: {
                  display: true,
                  text: `${props.title}`,
                  position: "center",
                  font: {
                    size: 18,
                  },
                  color: `${props.sidebar ? "#001823" : "white"}`,
                  padding: {
                    top: 10,
                    left: 2,
                  },
                },
                labels: {
                  generateLabels: function (chart) {
                    return [];
                  },
                },
              },
            },
            scales: {
              xAxes: {
                grid: {
                  display: false,
                  borderWidth: 0,
                },
                ticks: {
                  color: "#ffffff",
                },
              },
              yAxes: {
                display: false,
              },
            },
          },
        });
        setChartInstance(someChart);
        return () => {
          someChart.destroy();
        };
      }
    }
  }, [canvasRef, props.plotData]);
  return (
    <CanvasContainer sidebar={props.sidebar}>
      <canvas ref={canvasRef} id="myChart"></canvas>
      {/* <canvas ref={canvasRefSidebar} id="myChart"></canvas> */}
      {/* <div className="annotation"></div> */}
    </CanvasContainer>
  );
};

export default EngagementChart;

const CanvasContainer = styled.div<{ sidebar?: boolean }>`
  border-radius: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 5px;
  background-image: ${(props) => (props.sidebar ? "" : `url(${BlueBG})`)};
  background-size: cover;
  position: relative;
  cursor: pointer;
  canvas {
    background-color: white;
    height: 345px;
    border-radius: 8px;
    /* offset-x | offset-y | blur-radius | spread-radius | color */
    box-shadow: ${(props) => (props.sidebar ? "0 0 12px -1px rgba(0, 0, 0, 0.12)" : "")};
    background-image: ${(props) => (props.sidebar ? "" : `url(${BlueBG})`)};
    background-size: cover;
    width: 100%;
    max-width: 100% !important;
    height: 100% !important;
  }
  .annotation {
    position: absolute;
    background-color: #71d2ff;
    border-radius: 6.5px;
    width: 13px;
    height: 116px;
    opacity: 0.74;
    right: 15px;
    bottom: 49px;
    max-height: calc(100% - 65px);
  }
`;
